import { render, staticRenderFns } from "./Proposals.vue?vue&type=template&id=6e449642&scoped=true"
import script from "./Proposals.vue?vue&type=script&lang=js"
export * from "./Proposals.vue?vue&type=script&lang=js"
import style0 from "./Proposals.vue?vue&type=style&index=0&id=6e449642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e449642",
  null
  
)

export default component.exports